import { UrlApi } from "../../../services/apirest";
import {
  getCachedVerificacion,
  invalidateListaNegraCache,
  setCachedVerificacion,
} from "./listaNegraCache";
import { normalizarCuit } from "./listaNegra.constants";

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    qs.set(key, String(value));
  });
  const query = qs.toString();
  return query ? `?${query}` : "";
};

const authHeaders = (extra = {}) => {
  const token = localStorage.getItem("token");
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
};

const parseJsonSafe = async (res) => {
  try {
    return await res.json();
  } catch {
    return {};
  }
};

const throwIfError = (res, data, fallback) => {
  if (!res.ok || data?.ok === false) {
    const error = new Error(
      data?.msg || data?.message || data?.error || fallback
    );
    error.status = res.status;
    error.codigo = data?.codigo ?? null;
    error.data = data;
    throw error;
  }
};

export { invalidateListaNegraCache };

export const getListaNegra = async (filtros = {}) => {
  const { activo = 1, q, limit = 50, offset = 0 } = filtros;
  const query = buildQuery({ activo, q, limit, offset });
  const res = await fetch(`${UrlApi}/cheques/lista-negra${query}`, {
    headers: authHeaders(),
  });
  const data = await parseJsonSafe(res);
  throwIfError(res, data, "No se pudo obtener la lista negra");
  return data;
};

export const getListaNegraByCuit = async (cuit) => {
  const cuitNorm = normalizarCuit(cuit);
  if (cuitNorm.length < 8) {
    throw new Error("CUIT inválido");
  }
  const res = await fetch(`${UrlApi}/cheques/lista-negra/${cuitNorm}`, {
    headers: authHeaders(),
  });
  const data = await parseJsonSafe(res);
  throwIfError(res, data, "No se pudo obtener el detalle del emisor");
  return data;
};

export const liberarCuitListaNegra = async (cuit, body = {}) => {
  const cuitNorm = normalizarCuit(cuit);
  const res = await fetch(`${UrlApi}/cheques/lista-negra/${cuitNorm}/liberar`, {
    method: "PATCH",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(body ?? {}),
  });
  const data = await parseJsonSafe(res);
  throwIfError(res, data, "No se pudo rehabilitar el CUIT");
  invalidateListaNegraCache();
  return data;
};

export const verificarCuitListaNegra = async (cuit, { usarCache = true } = {}) => {
  const cuitNorm = normalizarCuit(cuit);
  if (cuitNorm.length < 8) {
    return { bloqueado: false, cuit: cuitNorm };
  }
  if (usarCache) {
    const cached = getCachedVerificacion(cuitNorm);
    if (cached) return cached;
  }
  const query = buildQuery({ cuit: cuitNorm });
  const res = await fetch(`${UrlApi}/cheques/lista-negra/verificar${query}`, {
    headers: authHeaders(),
  });
  const data = await parseJsonSafe(res);
  throwIfError(res, data, "No se pudo verificar el CUIT");
  setCachedVerificacion(cuitNorm, data);
  return data;
};

export {
  extraerMotivosRechazo,
  getMotivosRechazo,
} from "../cheques_proveedores/ApiServices";

/** Normaliza filas del listado GET /cheques/lista-negra. */
export const extraerEmisoresListaNegra = (data) => {
  if (Array.isArray(data?.emisores)) return data.emisores;
  if (Array.isArray(data?.lista)) return data.lista;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data)) return data;
  return [];
};
